import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";

import startHotjar from "./startHotjar";

const hj = (...args: any[]) => {
  const params = Array.prototype.slice.call(args);
  const globalHotjar = getGlobalProperty<(...args: any[]) => void>("hj");
  if (!globalHotjar) {
    throw new Error("Hotjar is not initialized");
  }

  globalHotjar(...params);
};

export class Hotjar {
  static initialize = (hjid: number, hjsv: number) => {
    startHotjar(hjid, hjsv);
  };
  static identify = (userId: string, properties: Record<string, any>) => {
    hj("identify", userId, properties);
  };
  static event = (event: string) => {
    hj("event", event);
  };
  static stateChange = (relativePath: string) => {
    hj("stateChange", relativePath);
  };
}
